import React, { useEffect, useState } from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { Alert, Container, Loader, Tabs } from '@itds/elements/index.js';

import Avatar from '@brokerage/components/Avatar';
import General from './member/General';
import Agencies from './member/Agencies';
import MobileDevices from './member/MobileDevices';
import NotificationTriggers from './member/NotificationTriggers';
import ChangePassword from './member/ChangePassword';

import { Api } from '@brokerage/utils/Api';

const Show = () => {
  const params = useParams();

  const [agencies, setAgencies] = useState([]);
  const [error_message, setErrorMessage] = useState();
  const [loading, setLoading] = useState(true);
  const [member, setMember] = useState(null);
  const [success_message, setSuccessMessage] = useState();

  useEffect(() => {
    loadMember();
  }, []);

  const loadMember = () => {
    setLoading(true);

    Api.loadMember(params.id).then(({ data }) => {
      setMember(data);
      setLoading(false);
    });

    Api.loadAgencies().then(({ data }) => {
      setAgencies(data);
    });
  };

  const handleFileChange = (name, e) => {
    Api.updateMember(member.id, { [name]: e.target.files[0] }).then(({ data }) => {
      setMember({ ...member, image: data.image.url });
      loadMember();
    });
  };

  const child_props = {
    agencies,
    loadMember,
    member,
    setErrorMessage,
    setSuccessMessage
  };

  return loading ? (
    <Loader />
  ) : (
    <Container>
      {member.is_locked ? (
        <Alert type='error'>This account has been locked due to 5 failed log in attempts.</Alert>
      ) : null}

      {error_message ? <Alert type='error'>{error_message}</Alert> : null}
      {success_message ? <Alert type='success'>{success_message}</Alert> : null}

      <div style={{ display: 'flex', marginBottom: '30px' }}>
        <input
          accept='image/*'
          id='icon-button-file'
          onChange={handleFileChange.bind(null, 'image')}
          style={{ display: 'none' }}
          type='file'
        />
        <label htmlFor='icon-button-file'>
          <Avatar image={member.image.url} large={true} />
        </label>

        <div style={{ marginTop: 'auto', marginBottom: 'auto' }}>
          <div
            style={{
              fontFamily: 'Quicksand',
              fontSize: '20px',
              fontWeight: 500
            }}
          >
            {member.first_name} {member.last_name}
          </div>
        </div>
      </div>

      <Tabs
        tabs={[
          {
            isActive: window.location.hash.includes('general'),
            label: 'General',
            to: 'general'
          },
          {
            isActive: window.location.hash.includes('agencies'),
            label: 'Agencies',
            to: 'agencies'
          },
          {
            isActive: window.location.hash.includes('mobile_devices'),
            label: 'Mobile Devices',
            to: 'mobile_devices'
          },
          {
            isActive: window.location.hash.includes('notification_triggers'),
            label: 'Notification Triggers',
            to: 'notification_triggers'
          },
          {
            isActive: window.location.hash.includes('change_password'),
            label: 'Change Password',
            to: 'change_password'
          }
        ]}
      />

      <div style={{ padding: '40px 20px' }}>
        <Routes>
          <Route element={<General {...child_props} />} path='general' />
          <Route element={<Agencies {...child_props} />} path='agencies' />
          <Route element={<MobileDevices {...child_props} />} path='mobile_devices' />
          <Route element={<NotificationTriggers {...child_props} />} path='notification_triggers' />
          <Route element={<ChangePassword {...child_props} />} path='change_password' />
        </Routes>
      </div>
    </Container>
  );
};

export default Show;
